import Image from 'next/image'
import Link from 'next/link'
import styled from 'styled-components'

import { emSpaces, spaces } from '@/config/global-parameters'

import reportAnalytics from '../2023/plebiscito/components/plebiscito/reportAnalytics'
import { Banner as BannerType, BannerProviderProps } from '../providers/BannerProvider'
import { useEnvironment } from '../providers/EnvironmentProvider'

type IBanner = {
  alt?: string
  size?: keyof BannerType
  index: number
  height: number
  width?: number
}

const Banner = ({ alt = 'banner', height, index, size = 'bigPath', width = 1 }: IBanner) => {
  const { banners } = useEnvironment<BannerProviderProps>()
  const bannerPath = banners[index][size]
  const bannerLink = banners[index].href
  return (
    <Link
      href={banners[index].href}
      onClick={() => reportAnalytics('clicked_banner', bannerLink)}
      target="_blank"
    >
      <Wrapper
        alt={alt}
        height={height}
        src={bannerPath}
        width={width}
      />
    </Link>
  )
}

type BannerCoupleProps = {
  alt1?: string
  alt2?: string
  height: number
  index1: number
  index2: number
}

export const BannerCouple = ({
  alt1 = 'banner',
  alt2 = 'banner2',
  height,
  index1,
  index2,
}: BannerCoupleProps) => {
  return (
    <WrapperCouple>
      <Banner
        alt={alt1}
        height={height}
        index={index1}
        size="smallPath"
      />
      <Banner
        alt={alt2}
        height={height}
        index={index2}
        size="smallPath"
      />
    </WrapperCouple>
  )
}

export const BannerUnholster = ({ height = 100 }: { height?: number }) => (
  <LinkMobile
    href="https://info.unholster.com/suscribirse-noticias"
    onClick={() => reportAnalytics('clicked_banner', 'https://info.unholster.com/suscribirse-noticias')}
    passHref
    target="_blank"
  >
    <Unholster
      alt="banner-unholster-mobile"
      height={height}
      src="/banners/DC_Banner_Unholster.gif"
      width={565 / height}
    />
  </LinkMobile>
)

const Wrapper = styled(Image)`
  width: 100%;
  max-height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
  height: min-content;
  margin: ${spaces.m} 0;
`
const LinkMobile = styled(Link)``

const WrapperCouple = styled.div`
  width: 100%;
  display: grid;
  grid: 1fr / 1fr 1fr;
  gap: ${emSpaces.s};
`
const Unholster = styled(Image)`
  width: 100%;
  height: min-content;
`

export default Banner
